import { Moment } from 'moment-timezone';

export interface SalesDashboardFilters {
    startDate: Moment;
    endDate: Moment;
    compareStartDate?: Moment;
    compareEndDate?: Moment;
    businessTypes?: string[];
    marketplaces?: number[];
    regions?: string[];
}

export interface DateRange {
    start: Moment;
    end: Moment;
}

export interface KpiMetric {
    amount: number;
    avgPrice: number;
    changePct?: number;
}

export interface KpiSummary {
    totalSales: KpiMetric;
    boarding: KpiMetric;
    daycare: KpiMetric;
    grooming: KpiMetric;
    addons: KpiMetric;
    products: KpiMetric;
    customItems: KpiMetric;
}

export interface SalesAttributionDataPoint {
    month: string;
    netSales: number;
}

export interface SalesAttributionSeries {
    key: string;
    label: string;
    data: SalesAttributionDataPoint[];
}

export interface SalesAttribution {
    range: DateRange;
    series: SalesAttributionSeries[];
}

export enum TopItemsType {
    Services = 'services',
    Products = 'products',
    Addons = 'addons',
    CustomItems = 'custom_items'
}

export interface TopItem {
    ranking: number;
    name: string;
    sales: number;
    sold: number;
}

export interface TopItems {
    type: TopItemsType;
    range: DateRange;
    meta: {
        page: number;
        perPage: number;
        totalCount: number;
    };
    items: Array<TopItem>;
}

export interface SparklinePoint {
    month: string;
    amount: number;
}

export interface AdjustmentBucket {
    total: string;
    sparkline: SparklinePoint[];
    compareTotal: string;
    compareSparkline: SparklinePoint[];
    changePct: string | null;
}

export interface Adjustments {
    range: DateRange;
    refunds: AdjustmentBucket;
    chargebacks: AdjustmentBucket;
    forfeitedDeposits: AdjustmentBucket;
}

export interface LeaderboardLocation {
    marketplaceId: number;
    name: string;
    region: string | null;
    netSales: number;
    avgOrderValue: number;
    salesPerStaff: number;
    activeClients: number;
    newClients: number;
    retentionRate: number;
    ranking: number;
}

export enum LeaderboardSortBy {
    NetSales = 'net_sales',
    AvgOrderValue = 'avg_order_value',
    SalesPerStaff = 'sales_per_staff',
    ActiveClients = 'active_clients',
    NewClients = 'new_clients',
    RetentionRate = 'retention_rate'
}

export interface Leaderboard {
    range: DateRange;
    sortBy: LeaderboardSortBy;
    locations: LeaderboardLocation[];
}

export interface TopItemsParams extends SalesDashboardFilters {
    type?: TopItemsType;
    page?: number;
    perPage?: number;
    query?: string;
}

export interface LeaderboardParams extends SalesDashboardFilters {
    sortBy?: LeaderboardSortBy;
}
